import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import FileTag from "./FileTag";

const FileInput = ({ item }) => {
  const {
    label,
    name,
    type,
    defaultValue,
    multiple,
    multipleData,
    fullCol,
    required,
    handleSingleDelete,
  } = item;

  const [quantityCount, setCount] = useState(multipleData);
  const handleAddElement = () => {
    setCount((current) => [
      ...current,
      {
        label: label,
        type: "file",
        name: "",
        defaultValue: "",
      },
    ]);
  };
  return (
    <div
      className={
        fullCol
          ? "col-span-1 flex flex-col items-center md:flex-row gap-4 md:items-start justify-start w-full"
          : "flex flex-col items-center md:flex-row gap-4 md:items-end w-full"
      }
    >
      <div
        className={
          fullCol
            ? "grid grid-cols-1 gap-x-4 gap-y-5 w-full"
            : "grid md:grid-cols-2 gap-x-4 gap-y-5 w-full"
        }
      >
        {multipleData ? (
          quantityCount.map((item, index) => (
            <FileTag
              key={index}
              label={label}
              length={index + 1}
              name={name}
              defaultValue={item.defaultValue}
              type={type}
              multiple={multiple}
              handleSingleDelete={handleSingleDelete}
            />
          ))
        ) : (
          <FileTag
            label={label}
            length={0}
            name={name}
            defaultValue={defaultValue}
            type={type}
            multiple={multiple}
            required={required}
          />
        )}
      </div>

      {multiple && (
        <div className="flex justify-center items-end">
          <button
            onClick={handleAddElement}
            type="button"
            className="btn btn-circle border border-gray-400 rounded-full p-4 hover:bg-gray-50"
          >
            <BsPlusLg />
          </button>
        </div>
      )}
    </div>
  );
};

export default FileInput;
